import { makeAutoObservable } from 'mobx';
import { PublicConfig } from 'nfty-common/lib/model/firebase-schema';
import { createContext } from 'react';
import { publicRef } from '../services/firebase.service';
import { AuctionStore } from './auction.store';
import { LoadableStore } from './loadable.store';
import { ThemeStore } from './theme.store';
import { WalletStore } from './wallet.store';

export class App {
    appLoaded = false;
    config = new PublicConfig();
    stores = new Map<string, LoadableStore>();
    auctionStore: AuctionStore;
    themeStore: ThemeStore;
    walletStore: WalletStore;

    constructor() {
        makeAutoObservable(this, {
            stores: false,
            registerStore: false
        });

        this.auctionStore = new AuctionStore(this);
        this.themeStore = new ThemeStore(this);
        this.walletStore = new WalletStore(this);
    }

    async loadAppData() {
        const snap = await publicRef.child('config').get();
        if (snap.exists()) {
            this.config = snap.val() as PublicConfig;
        }

        const promises: Array<Promise<any>> = [];
        this.stores.forEach((store) => {
            promises.push(store.load());
        })

        await Promise.all(promises);
        this.setAppLoaded();
    }

    registerStore(name: string, loader: LoadableStore) {
        this.stores.set(name, loader);
    }

    setAppLoaded(newValue: boolean = true) {
        this.appLoaded = newValue;
    }
}

const _store = new App();
export const AppContext = createContext(_store);
export const AppStore = _store;